// extracted by mini-css-extract-plugin
export default {"preButtonText":"style_preButtonText__3oMmP","buttonImage":"style_buttonImage__9IQQv","svg":"style_svg__zLlkg","whatIsFranceConnect":"style_whatIsFranceConnect__OCjTm"};